import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-689efe22")

_pushScopeId("data-v-689efe22")
const _hoisted_1 = { class: "teamTable" }
const _hoisted_2 = { class: "teamTable-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "teamTable-title mb16" }, "#队伍", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "row-operating"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "btn-vertical" }, "|", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = {
  key: 1,
  class: "row-edit"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "btn-vertical" }, "|", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "添加部门队伍", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")
  const _component_a_table = _resolveComponent("a-table")
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_spin, {
        spinning: _ctx.props.loading
      }, {
        default: _withId(() => [
          _hoisted_3,
          _createVNode(_component_a_table, {
            class: "mb16",
            columns: _ctx.columns,
            "data-source": _ctx.dataSource,
            pagination: false,
            rowKey: "id"
          }, _createSlots({
            operation: _withId(({ record, index }) => [
              _createVNode("div", null, [
                (_ctx.editableData[record.id])
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (_ctx.save(record.id)),
                        disabled: _ctx.props.disable
                      }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _hoisted_8,
                      _createVNode(_component_a_popconfirm, {
                        title: "确认放弃编辑？",
                        onConfirm: ($event: any) => (_ctx.cancel(record.id, record, index)),
                        disabled: _ctx.props.disable
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_a_button, {
                            type: "link",
                            disabled: _ctx.props.disable
                          }, {
                            default: _withId(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 2
                      }, 1032, ["onConfirm", "disabled"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (_ctx.edit(record.id)),
                        disabled: _ctx.props.disable
                      }, {
                        default: _withId(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      _hoisted_12,
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (_ctx.del(record.id, index)),
                        disabled: _ctx.props.disable
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]))
              ])
            ]),
            _: 2
          }, [
            _renderList(["teamName", "peopleQuantity", "arrivalTime", "rescueCapability"], (col) => {
              return {
                name: col,
                fn: _withId(({ text, record }) => [
                  (_ctx.editableData[record.id])
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        (col === "teamName")
                          ? (_openBlock(), _createBlock(_component_a_input, {
                              key: 0,
                              value: _ctx.editableData[record.id][col],
                              "onUpdate:value": ($event: any) => (_ctx.editableData[record.id][col] = $event),
                              style: {"margin":"-5px 0"},
                              placeholder: "请输入内容",
                              maxlength: 10,
                              disabled: _ctx.props.disable
                            }, null, 8, ["value", "onUpdate:value", "disabled"]))
                          : _createCommentVNode("", true),
                        (col === "peopleQuantity" || col === "rescueCapability")
                          ? (_openBlock(), _createBlock(_component_a_input_number, {
                              key: 1,
                              value: _ctx.editableData[record.id][col],
                              "onUpdate:value": ($event: any) => (_ctx.editableData[record.id][col] = $event),
                              style: {"margin":"-5px 0"},
                              min: 0,
                              max: 100,
                              precision: 0,
                              disabled: _ctx.props.disable
                            }, null, 8, ["value", "onUpdate:value", "disabled"]))
                          : _createCommentVNode("", true),
                        (col === "arrivalTime")
                          ? (_openBlock(), _createBlock(_component_a_input_number, {
                              key: 2,
                              value: _ctx.editableData[record.id][col],
                              "onUpdate:value": ($event: any) => (_ctx.editableData[record.id][col] = $event),
                              style: {"margin":"-5px 0"},
                              min: 0,
                              max: 200,
                              precision: 0,
                              disabled: _ctx.props.disable
                            }, null, 8, ["value", "onUpdate:value", "disabled"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        (col === "arrivalTime")
                          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(text) + "min", 1))
                          : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(text), 1))
                      ], 64))
                ])
              }
            })
          ]), 1032, ["columns", "data-source"]),
          _createVNode(_component_a_button, {
            class: "teamTable-add user-select-none",
            onClick: _ctx.add,
            disabled: _ctx.addBtnDisable || _ctx.props.disable
          }, {
            default: _withId(() => [
              _createVNode(_component_SvgIcon, {
                class: "my-icon mr8",
                icon: "add"
              }),
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 1
      }, 8, ["spinning"])
    ])
  ]))
})